export const BUSINESS = {
  name: "Shine Space Beauty Salon",
  area: "Bur Dubai",
  phoneDisplay: "050 179 9925",
  phoneTel: "tel:+971501799925",
  whatsapp: "https://wa.me/971501799925",
  whatsappWithText: (text) =>
    `https://wa.me/971501799925?text=${encodeURIComponent(text)}`,
  address:
    "Khalid Bin Al Waleed Rd, Al Souq Al Kabeer, Al Fahidi, Bur Dubai, UAE",
  hours: "Open Daily · From 9:30 AM",
  rating: "4.2",
  reviewCount: "10",
  mapsEmbed:
    "https://www.google.com/maps?q=Shine+Space+Beauty+Salon+Khalid+Bin+Al+Waleed+Rd+Bur+Dubai&output=embed",
  mapsLink:
    "https://www.google.com/maps/search/?api=1&query=Shine+Space+Beauty+Salon+Khalid+Bin+Al+Waleed+Rd+Bur+Dubai",
};

export const SERVICES = [
  "Hair — Cut, Colour & Keratin",
  "Nails — Manicure, Pedicure & Gel",
  "Facials & Skin Care",
  "Waxing & Threading",
  "Henna / Mehndi Art",
  "Other / Not sure yet",
];

const img = (id, w = 1200) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMAGES = {
  hero: img("photo-1600948836101-f9ffda59d250", 2000),
  portrait: img("photo-1524504388940-b1c1722653e1", 900),
  hair: img("photo-1580618672591-eb180b1a973f"),
  nails: img("photo-1610992015762-45dca7fa3a85"),
  facial: img("photo-1643684391140-c5056cfd3436"),
  waxing: img("photo-1544161515-4ab6ce6db874"),
  henna: img("photo-1732118400647-a81e3b37be87"),
};
